'use client';

import type { BioContext } from '@ps/functions/bio/bioContext';
import type { PopStoreExtendedSubscriptionLevel } from '@ps/models/lib/creator-subscription';

import { ChatGlobalProvider } from '../../messaging/contexts/global/provider';
import { BioUserAccessProvider } from '../contexts/user-access/provider';
import { DmGate } from './DmGate';

interface Props {
  /** Creator user id == the DM peer / target == profile.id. */
  creatorId: string;
  creatorName: string;
  creatorAvatar?: string;
  dmMinimumSubscriptionLevel?: PopStoreExtendedSubscriptionLevel;
  bioContext: BioContext;
  /** Leaves the chat (modal → router.back; standalone → back to bio). */
  onClose?: () => void;
}

/**
 * The gated visitor DM surface, host-agnostic: it wraps the subscription-standing
 * context ({@link BioUserAccessProvider}) + the messaging providers
 * ({@link ChatGlobalProvider}: websocket gateway + sessions) around {@link DmGate}.
 * The host (standalone page or intercept modal) provides the shell; this renders
 * only the gated content. Requires a signed-in `AuthProvider`/`UserProfileProvider`
 * above (supplied by the `/chat` layout and the `@modal` layout respectively).
 */
export function MessageCreatorSurface({
  creatorId,
  creatorName,
  creatorAvatar,
  dmMinimumSubscriptionLevel,
  bioContext,
  onClose,
}: Props) {
  return (
    <BioUserAccessProvider creatorId={creatorId}>
      <ChatGlobalProvider>
        <DmGate
          creatorId={creatorId}
          creatorName={creatorName}
          creatorAvatar={creatorAvatar}
          dmMinimumSubscriptionLevel={dmMinimumSubscriptionLevel}
          bioContext={bioContext}
          onClose={onClose}
        />
      </ChatGlobalProvider>
    </BioUserAccessProvider>
  );
}
